import React from 'react'
import { Wrapper } from './style'
import { PasswordForm } from './Password'
import { Link } from 'react-router-dom'
import { circleTwo } from 'src/assets'
const SecurePasswordPage = () => {
  return (
    <Wrapper>
      <div className="rex">
        <Link to="/accounts/register" className="option-link">
          <p className="back">Back</p>
        </Link>
        <div className="step">
          <img src={circleTwo} alt="" />
          <div className="details">
            <p className="step-topic">Step 2</p>
            <p>Personal details</p>
          </div>
        </div>
      </div>
      <PasswordForm />
    </Wrapper>
  )
}

export { SecurePasswordPage }
